import { PORTFOLIO_ADMIN_CONSTANTS as C } from '../../_Shared/_MODULES/PortfolioAdminApi';
export const SOCIALS_ADMIN_API = { LIST: C.SOCIALS_LIST, SAVE: C.SOCIALS_SAVE, REMOVE: C.SOCIALS_REMOVE };
